"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TDNodeProxyHandler = exports.TRANSIENT_DATA_KEY_EXTENDED_FIELDS = void 0;
var LangUtil_1 = require("./core/LangUtil");
var TDNode_1 = require("./TDNode");
var TARGET = "$target";
var KEY = "$key";
exports.TRANSIENT_DATA_KEY_EXTENDED_FIELDS = "$extendedFields";
var TDNodeProxyHandler = /** @class */ (function () {
    function TDNodeProxyHandler(useCache) {
        this.useCache = useCache;
    }
    TDNodeProxyHandler.prototype.get = function (target, prop, receiver) {
        // console.log(`prop: ${prop.toString()}`);
        if (prop === Symbol.toPrimitive) {
            return target.toString();
        }
        if (typeof (prop) !== 'string') {
            console.log("Got unknown symbol prop: " + prop.toString());
            return target[prop];
        }
        // console.log(`get: p=${p}, target=${target.pathAsString}`);
        if (prop === 'length')
            return target.getChildrenSize();
        if (prop === TARGET)
            return target;
        if (prop === KEY)
            return target.key;
        var extendedFields = target.tData[exports.TRANSIENT_DATA_KEY_EXTENDED_FIELDS];
        if (extendedFields && extendedFields[prop])
            return extendedFields[prop](receiver);
        var idx = Number(prop);
        var c = LangUtil_1.LangUtil.isNumber(idx) ? target.getChild(idx) : target.getChild(prop);
        if (c) {
            if (c.type === TDNode_1.TDNodeType.SIMPLE)
                return c.value;
            // TODO: Support reference objects of $ref
            return c.toProxy(this.useCache);
        }
        // Prevent: Function Proxy .toString() Errors
        // https://stackoverflow.com/questions/38259885/function-proxy-tostring-errors
        var res = target[prop];
        // return res;
        // console.log(`prop: ${prop}, res:${res}, typeof res=${typeof res}`);
        return (typeof res === 'function') ? res.bind(target) : res;
    };
    return TDNodeProxyHandler;
}());
exports.TDNodeProxyHandler = TDNodeProxyHandler;
//# sourceMappingURL=TDNodeProxyHandler.js.map